import FormattedMessage from 'I18n/components/FormattedMessage';
import { AgentIconWithFallback } from 'ai-components-ui-library/components/icons/AgentIconWithFallback';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useLocation } from 'react-router-dom';
import { useFilterConfig } from '../../hooks/useFilterConfig';
import { ToggleFilter } from '../reusableFilters/ToggleFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BreezeFilter() {
  const {
    pathname
  } = useLocation();
  const {
    WORKS_WITH_BREEZE
  } = useFilterConfig();
  if (!WORKS_WITH_BREEZE) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsxs(Flex, {
      gap: "200",
      children: [/*#__PURE__*/_jsx(AgentIconWithFallback, {
        size: 20,
        background: "none",
        marginBlockEnd: "0"
      }), /*#__PURE__*/_jsx(Text, {
        as: "label",
        htmlFor: WORKS_WITH_BREEZE.field,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.universal.breeze.label"
        })
      })]
    }), pathname === '/featured/breeze-assistant' ? /*#__PURE__*/_jsx(Toggle, {
      checked: true,
      disabled: true,
      id: WORKS_WITH_BREEZE.field,
      size: "extra-small"
    }) : /*#__PURE__*/_jsx(ToggleFilter, {
      filter: WORKS_WITH_BREEZE
    })]
  });
}